import { useParams } from "react-router-dom";
import { PremiumPubWrapper } from "./style";
import { usePubContext } from "./hooks/pub-context";
import { useEffect } from "react";
import PremiumPubHeader from "./components/header";
import PremiumPubBanner from "./components/banner";
import PremiumPubTournaments from "./components/tournaments";
import ReservationCancelPopup from "../MyReservation/component/isCancel";
import PremiumPubFloatingMenu from "./components/floating-menu";
import LocationSheet from "../../../components/web/LocationSheet";
import OpenApp from "../../../components/openApp";
import { PremiumPubPage } from "./hooks/use-pub-tab";
import PremiumPubInfo from "./components/info";
import PremiumPubYoutubeLive from "./components/youtube-live";
import PremiumPubLocation from "./components/location";
import PremiumPubEvent from "./components/event";
import PremiumPubReview from "./components/review";
import ReviewWrite from "../StoreDetail/WriteReview";
import PremiumPubRestaurant from "./components/restaurant";

const PremiumPub = () => {
  const { id } = useParams<{ id: string }>();
  const {
    setPubId,
    isReservationCancel,
    setIsReservationCancel,
    handleCancel,
    isPubPage,
    isOpenUseApp,
    goToApp,
    setIsOpenUseApp,
    liveList,
    loading,
    showWrite,
    setShowWrite,
    getData,
    editReview,
    setEditReview,
  } = usePubContext();

  useEffect(() => {
    setPubId(+id);
  }, [id]);

  const handleCloseReviewWrite = () => {
    getData();
    setShowWrite(false);
    setEditReview(null);
  };

  return (
    <>
      {/* 앱 안내 팝업 */}
      {isOpenUseApp && (
        <OpenApp
          openApp={() => goToApp()}
          onClose={() => setIsOpenUseApp(false)}
        />
      )}
      {/* 예약 취소 팝업 */}
      {isReservationCancel && (
        <ReservationCancelPopup
          onClose={() => setIsReservationCancel(false)}
          handleCancel={handleCancel}
        />
      )}
      {/* 리뷰 작성 팝업 */}
      {showWrite && (
        <ReviewWrite
          mode={editReview ? "edit" : "write"}
          onClose={handleCloseReviewWrite}
          rate={editReview ? editReview.score : 5}
          reviewData={editReview || undefined}
          pubId={+id}
        />
      )}
      <LocationSheet /> {/* 길찾기 팝업 */}
      <PremiumPubWrapper>
        <PremiumPubHeader /> {/* 해더 */}
        <PremiumPubFloatingMenu /> {/* 메뉴바 */}
        {/* 유튜브 라이브 */}
        {liveList.length > 0 && !loading && <PremiumPubYoutubeLive />}
        <PremiumPubBanner /> {/* 배너 */}
        <PremiumPubTournaments /> {/* 토너먼트 */}
        {isPubPage(PremiumPubPage.INFO) && <PremiumPubInfo />}
        {isPubPage(PremiumPubPage.LOCATION) && <PremiumPubLocation />}
        {isPubPage(PremiumPubPage.EVENT) && <PremiumPubEvent />}
        {isPubPage(PremiumPubPage.REVIEW) && <PremiumPubReview />}
        {isPubPage(PremiumPubPage.RESTAURANT) && <PremiumPubRestaurant />}
      </PremiumPubWrapper>
    </>
  );
};

export default PremiumPub;
